import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { useSelector } from 'react-redux';
import { fromStore } from '../selectors';
import { request } from '../utils';

const shopData = {
  name: 'Sushibox',
  company: 'ООО "Южный Берег"',
  url: 'https://sushibox.one/',
};

export default function YMLPage() {
  const categories = useSelector(fromStore.denormalizedCategories);
  const [offers, setOffers] = useState(null);

  useEffect(() => {
    const getGoods = async () => {
      const goods = await request({ method: 'get', url: '/items_yml' });
      const result = goods.map((item) => ({
        id: item.id,
        name: item.name,
        available: true,
        url: item.link,
        price: item.price,
        categoryId: item.category,
        description: item.description,
        oldPrice: item.oldPrice ? item.oldPrice : null,
        picture: item.image ? item.image : null,
      }));

      setOffers(result);
    };

    getGoods();
  }, []);

  return (
    <>
      {'<?xml version="1.0" encoding="UTF-8"?>'}
      <yml_catalg date={dayjs().format()}>
        <shop>
          <name>{shopData.name}</name>
          <company>{shopData.company}</company>
          <url>{shopData.url}</url>
          <currencies>
            <currency id="RUB" rate="1" />
          </currencies>
          <categories>
            {categories.map((item) => (
              <category key={`category-${item.id}`} id={item.id}>{item.title}</category>
            ))}
          </categories>
          <offers>
            {offers && offers.map((item) => (
              <offer key={`good-${item.id}`} id={item.id} available="true">
                <url>{item.url}</url>
                <name>{item.name}</name>
                <price>{item.price}</price>
                <currencyId>RUB</currencyId>
                <categoryId>{item.categoryId}</categoryId>
                <picture>{item.picture}</picture>
                <description>{item.description}</description>
                {item.oldPrice && <oldPrice>{item.oldPrice}</oldPrice>}
              </offer>
            ))}
          </offers>
        </shop>
      </yml_catalg>
    </>
  );
}
